"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var function_1 = require("fp-ts/lib/function");
var ObjectUtils;
(function (ObjectUtils) {
    ObjectUtils.isNotNullable = function (value) { return value !== null && value !== undefined; };
    ObjectUtils.shallowCopy_ = function (value) { return Object.assign({}, value); };
    ObjectUtils.shallowCopy = function (value) {
        return function_1.constant(ObjectUtils.shallowCopy_(value));
    };
    ObjectUtils.fromArray_ = function (key, array) {
        return array.reduce(function (acc, item) {
            acc[item[key]] = item;
            return acc;
        }, {});
    };
    ObjectUtils.fromArray = function_1.curry(ObjectUtils.fromArray_);
    ObjectUtils.byID = ObjectUtils.fromArray('id');
    ObjectUtils.groupBy = function (key, array) {
        return array.reduce(function (acc, item) {
            var keyValue = item[key];
            acc[keyValue] = (acc[keyValue] || []).concat([item]);
            return acc;
        }, {});
    };
    ObjectUtils.removeKey_ = function (key, obj) {
        var copy = ObjectUtils.shallowCopy_(obj);
        delete obj[key];
        return copy;
    };
    ObjectUtils.removeKey = function_1.curry(ObjectUtils.removeKey_);
    ObjectUtils.removeKeys = function (keys) { return function (obj) {
        return Object.keys(obj)
            .filter(function (key) { return !keys.includes(key); })
            .reduce(function (acc, key) {
            acc[key] = obj[key];
            return acc;
        }, {});
    }; };
    ObjectUtils.prop = function (key) { return function (obj) { return obj[key]; }; };
    ObjectUtils.mapValues = function (mapper) { return function (obj) {
        return Object.keys(obj).reduce(function (acc, key) {
            acc[key] = mapper(obj[key]);
            return acc;
        }, {});
    }; };
    ObjectUtils.assoc = function (key) { return function (value) { return function (obj) {
        var _a;
        return Object.assign({}, obj, (_a = {},
            _a[key] = value,
            _a));
    }; }; };
})(ObjectUtils = exports.ObjectUtils || (exports.ObjectUtils = {}));
